import React from 'react';
import PortfolioGrid from '../components/PortfolioGrid';
import Footer from '../components/Footer';
import './Portfolio.css';

const Portfolio = () => {
  return (
    <div className="portfolio-page">
      <PortfolioGrid limit={null} />
      <Footer />
    </div>
  );
};

export default Portfolio;

